import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
    async getSubjects(params) {
        try {
            const response = await axios.get('uni/subjects', { params })
            const { data } = response
            if (data.code === ApiCode.SUCCESS) {
                return data.data.records
            }
        } catch (e) {
            handleCatch(e)
        }
        return []
    },
}
